import React, { useState }  from 'react';
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from "react-i18next";

import { get360Data, goToTop, getLoading, setCursorWaiting, hideCmsHiddenBlock} from '../../../utils';

import { SummaryConstants as Constants } from '../../../Helpers/summaryconstants';
import SummaryCalculator from '../../../Helpers/summarycalculator';
import GTMHelper from '../../../Helpers/gtmHelper';
import NavHelper from '../../../Helpers/navhelper';

import Button from '../../1_Atoms/Button/Button';
import EngineCard from '../../2_Molecules/EngineCard/EngineCard';
import ThreeSixtyContainer from '../../3_Organisms/360Container/360Container';
import { Nav } from '../../3_Organisms/Nav/Nav';
import { Pricing } from '../../3_Organisms/Pricing/Pricing';
import { Modal } from '../../3_Organisms/Modal/Modal';
import { PreOrderModal } from '../../3_Organisms/Modal/PreOrderModal';
import PackageCard from '../../2_Molecules/PackageCard/PackageCard';
import { Alert } from '../../3_Organisms/Alert/Alert';

export const Options = (...props) => {
    const summaryCalculator = window.summaryCalculator;
    const [loading, setLoading] = useState(true);
    const [is360Loading, setIs360Loading] = useState(true);    
    const [firstEmptyDataLoad, setFirstEmptyDataLoad] = useState(false);
    const [dataNeedUpdate, setDataNeedUpdate] = useState(false);
    const [selectedModelIndex, setSelectedModelIndex] = useState(summaryCalculator.SelectedModelIndex);
    const [showFinancePrice, setShowFinancePrice] = React.useState(summaryCalculator.ShowFinancePrice);
    const { year, carline, trim, model, option } = useParams();    
    const listRef = React.useRef();
    const [nav, setNav] = React.useState(null);
    const navigate = useNavigate();
    const legalContent = JSON.parse(sessionStorage.getItem(Constants.LegalOption));
    const [legalModalOpen, setLegalModalOpen] = React.useState(false);
    const [images, setImages] = React.useState({});
    const { t, i18n } = useTranslation(['options', 'general']);

    const [preorderOpen, setPreorderModalOpen] = React.useState(false);
    
	const gtmHelper = new GTMHelper();
	const navHelper = new NavHelper();

    hideCmsHiddenBlock();

    function set360images() {
        if(!summaryCalculator.Colours)
            return;
        
        if (!Object.keys(images).length) {
            summaryCalculator.SetSelectedColorsFromParams();

            if (summaryCalculator.SelectedColourExteriorIndex > -1 && summaryCalculator.Colours) {
                const extArray = Object.entries(summaryCalculator.Colours.visual.exteriors);
                setImages(get360Data(summaryCalculator.Colours.visual, extArray[summaryCalculator.SelectedColourExteriorIndex][1], summaryCalculator.Colours.visual.interiors[summaryCalculator.SelectedColourInteriorIndex]));
                setIs360Loading(false);
            } else if (summaryCalculator.AvailableTrim) {
                setImages(get360Data(summaryCalculator.AvailableTrim.trims[summaryCalculator.SelectedTrimIndex].visual));
                setIs360Loading(false);
            } else if (summaryCalculator.EngineAndDrivetrain) {
                setImages(get360Data(summaryCalculator.SelectedModel.visual));
                setIs360Loading(false);
            }
        }
    }

    summaryCalculator.CurrentStep = 2;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    React.useEffect(() => {
        async function executeTasks() {
            if (window.bnp_under_maintenance)
                return;

            if (!firstEmptyDataLoad) {
                setFirstEmptyDataLoad(true);

                if (!summaryCalculator.isDataLoaded()) {
                    summaryCalculator.reset(false);

                    if(model || option) {
                        console.log('has package ', model, option);
                        await summaryCalculator.loadVehicleData(year, carline, trim, model, option);                    
                    } else {
                        await summaryCalculator.loadVehicleData(year, carline, trim);
                    }

                    if (JSON.parse(sessionStorage.getItem(Constants.HasFinancialProviderError)) === true) {
                        const vehiclePageUri = `/${decodeURI(window.location.search)}`;
                        navigate(vehiclePageUri)
                    }
                }

                setSelectedModelIndex(summaryCalculator.SelectedModelIndex);

                setDataNeedUpdate(true);

                setNav(null);

                setLoading(false);
            }

            if (!loading) {
                if (dataNeedUpdate) {
                    setDataNeedUpdate(false);

                    setLoading(true);

                    if (selectedModelIndex !== summaryCalculator.SelectedModelIndex) {
                        setCursorWaiting(true);
                        await summaryCalculator.setSelectedModelIndex(selectedModelIndex);

                        await summaryCalculator.updateSingleLineFromFinancialProvider();

                        updateAddressBar();

						gtmHelper.setGTM({'action':'Model Change'}, false, false);

                        setCursorWaiting(false);
                    } 
                    else {
                        if (model && option) {
                            console.log('has package ', model, option);
    
                            await summaryCalculator.loadVehicleData(year, carline, trim, model, option);
                        }
                    }


                    set360images();

                    const toRender = navHelper.getNavContent(t);
                    setNav(toRender);

                    setLoading(false);
                }
            }

            if (listRef.current) {
                window.removeEventListener('resize', setListMaxHeight);
                window.addEventListener('resize', setListMaxHeight);
                setListMaxHeight();
            }
        }

        executeTasks();
    }, [nav, carline, summaryCalculator, loading, dataNeedUpdate, showFinancePrice, is360Loading, selectedModelIndex]);

    function updateAddressBar() {
        const lang = document.querySelector('meta[name="data-language"]') ? document.querySelector('meta[name="data-language"]').content === 'en' ? 'en' : 'fr' : 'en';
        const province = document.querySelector('meta[name="data-region"]') ? document.querySelector('meta[name="data-region"]').content : 'on';        
        const urlPrefix = window.location.hostname === 'localhost' ? '' : lang === 'en' ? '/en/shopping/build-and-price' : '/fr/magasiner/construction-et-prix/';
        const url = `${urlPrefix}/#/${year}/${carline}/${trim}/${summaryCalculator.SelectedModel.model_code}/${summaryCalculator.SelectedPackage.option_code}?prov_code=${province}&lang_code=${lang}`;
        //history.replaceState('', 'React App', url);
        window.history.replaceState(null, 'React App', url);
    }

    React.useEffect(() => {
        // Redraw the 360 images
        set360images();
    }, [images]);

    async function handleSelectedPackage(index) {
        setCursorWaiting(true);

        await summaryCalculator.setSelectedPackageIndex(index);

        // This is a patch for the MX5 package selection
        await summaryCalculator.loadColours(year, carline, trim, summaryCalculator.SelectedModel.model_code, summaryCalculator.SelectedPackage.option_code);

        // Added these two call as wheels and accessories a package dependant
        await summaryCalculator.loadWheels(year, carline, trim, summaryCalculator.SelectedModel.model_code, summaryCalculator.SelectedPackage.option_code);
        await summaryCalculator.loadAccessories(year, carline, trim, summaryCalculator.SelectedModel.model_code, summaryCalculator.SelectedPackage.option_code);

        await summaryCalculator.updateSingleLineFromFinancialProvider();

        //setSelectedPackageIndex(index);
		gtmHelper.setGTM({'action':'Package Add', 'package': summaryCalculator.SelectedPackage.option_code}, false, false);

        const toRender = navHelper.getNavContent(t);
        setNav(toRender);

        updateAddressBar();

        // Refresh the 360 images
        setImages({});

        setCursorWaiting(false);
    }

    async function handleRemovePackage(index) {
        setCursorWaiting(true);

		gtmHelper.setGTM({'action':'Package Remove', 'package': summaryCalculator.SelectedPackage.option_code}, true, false);

        await summaryCalculator.setSelectedPackageIndex(null);

        // This is a patch for the MX5 package selection
        await summaryCalculator.loadColours(year, carline, trim, summaryCalculator.SelectedModel.model_code, summaryCalculator.SelectedPackage.option_code);

        // Added these two call as wheels and accessories a package dependant
        await summaryCalculator.loadWheels(year, carline, trim, summaryCalculator.SelectedModel.model_code, summaryCalculator.SelectedPackage.option_code);
        await summaryCalculator.loadAccessories(year, carline, trim, summaryCalculator.SelectedModel.model_code, summaryCalculator.SelectedPackage.option_code);

        await summaryCalculator.updateSingleLineFromFinancialProvider();

        const toRender = navHelper.getNavContent(t);
        setNav(toRender);

        updateAddressBar();

        // Refresh the 360 images
        setImages({});

        setCursorWaiting(false);

    } 
        
    function handleSelectedModel(index) {
        setCursorWaiting(true);

        setImages({});

        setSelectedModelIndex(index);

        setDataNeedUpdate(true);

        updateAddressBar();

        setNav(null);

        setCursorWaiting(false);
    }

    function nextStep() {
        if (summaryCalculator.SelectedModel) {
            goToTop();
            navigate(`/${year}/${carline}/${trim}/${summaryCalculator.SelectedModel.model_code}/${summaryCalculator.SelectedModel.option_code}/colours${decodeURI(window.location.search)}`);
        } else {
            goToTop();
            navigate(`/${year}/${carline}/${trim}/${summaryCalculator.EngineAndDrivetrain.models[0].financial.based_on.model_code}/${summaryCalculator.EngineAndDrivetrain.models[0].financial.based_on.option_code}/colours${decodeURI(window.location.search)}`);
        }
		gtmHelper.setGTM({'action':'Next Step'}, true , false);
    }

	function setListMaxHeight(){
        if (listRef.current)
            if (window.innerWidth < 1025) {
                listRef.current.style.maxHeight = 'unset';
            } else {
                const incentivebar = document.querySelector('.mz-alert__item'); // Red alert bar
				const submenu=document.querySelector(".mz-sticky-submenu");
				const pricingBar=
                listRef.current.style.height = `${window.innerHeight - (submenu?.offsetTop + document.querySelector(".mz-sticky-submenu")?.offsetHeight + document.querySelector(".mz-pricing")?.offsetHeight  + (incentivebar ? incentivebar.offsetHeight : 0) + 40)}px`;
				if(!submenu || !pricingBar){
					setTimeout(setListMaxHeight, 100);
				}
            }

    }

    function handleShowFinanceClick(value) {
        setShowFinancePrice(value);
    }

    return (
        <>
        {getLoading(loading, t)}
        <div className="mz-engine-and-drivetrain-page mz-top-nav-spacing grid-no-gutter-sm">
            <Nav nav={nav} />
            <Alert />

            {summaryCalculator.EngineAndDrivetrain?.models?.length ?
                <div key='0' className="mz-full-width mz-engine-and-drivetrain-page__content general-content">
                    <div className="mz-engine-and-drivetrain-page__content-left">
                        <ThreeSixtyContainer imagePathInterior={images.imagePathInterior} imagePath={images.imagePath} imageAmount={images.imageAmount} imageName={images.imageName} trimName={summaryCalculator.VehicleTitle} imageIsLoading={is360Loading} />
                    </div>
                    <div className="mz-engine-and-drivetrain-page__content-right">
                        <div className="mz-engine-and-drivetrain-page__engine-card-list" ref={listRef}>
                            <h5 className='mz-engine-and-drivetrain-page__engine-card-list-title'>{t("select_engine_and_drivetrain")}</h5>
                            {summaryCalculator.displayWarning() ? <div className={`mz-alert-message`}>
                                <i className="mz-svg mz-svg-warning mz-svg--red"></i>&nbsp;
                                <span className="mz-alert-message__text">{t("warning_change_selection")}</span>
                            </div> : null}
                            {summaryCalculator.EngineAndDrivetrain?.models.map((Model, index) => <EngineCard Model={Model} Selected={summaryCalculator.SelectedModelIndex === index} HandleSelectedModel={handleSelectedModel} Index={index} key={index} showFinancePrice={showFinancePrice}></EngineCard>)}

                            {summaryCalculator.Packages ? summaryCalculator.Packages.packages.filter(pack => pack.type === 'model_option_package').length ? <hr className="mz-package-page__content-separator" /> : null : null}
                            {summaryCalculator.Packages ? summaryCalculator.Packages.packages.filter(pack => pack.type === 'model_option_package').length > 0 && <h2 className='mz-package-page__package-card-list-title'>{t("packages:available_packages")}</h2> : null}
                            {summaryCalculator.Packages ? summaryCalculator.Packages.packages.filter(pack => pack.type === 'model_option_package').map((Package, index) =>      <PackageCard Package={Package} Selected={summaryCalculator.SelectedPackageIndex === index}
							SelectedIndex={summaryCalculator.SelectedPackageIndex === index?summaryCalculator.SelectedPackageIndex:''} HandleSelectedPackage={handleSelectedPackage} HandleRemovePackage={handleRemovePackage} Index={index} key={index} showFinancePrice={showFinancePrice}></PackageCard>)  : null}


                            <div className="mz-legal mz-mobile">
                                <Button
                                    className="mz-btn mz-btn--legal text--grey"
                                    label={t("general:legal")}
                                    backgroundColor="grey"
                                    colour="grey"
                                    icon={true}
                                    iconAfter={true}
                                    svg_className=""
                                    svg_list="plus"
                                    size={0.6}
                                    onClick={() => {
										document.querySelector('body').classList.add('disabled');
										setLegalModalOpen(true)
									}}
                                />
                            </div>
                        </div>                    
                    </div>
                </div>
                : null}

            {summaryCalculator.EngineAndDrivetrain?.models?.length && summaryCalculator.SelectedModel ?
                <Pricing builtLabel={t("general:price_as_built")} builtPrice="$" loanLabel={t("general:loan_label")} loanPrice="$" saveLabel={t("general:save_build")}
                    leaseLabel={t("general:show_lease_price")} financeLabel={t("general:show_finance_price")} buttonLabel={t("general:next_colour")}
                    HandleNextClick={nextStep} setLegalModalOpen={setLegalModalOpen} HandleShowFinanceClick={handleShowFinanceClick} setPreorderModalOpen={setPreorderModalOpen} /> : null}
            <Modal modalContent={legalContent} isOpen={legalModalOpen} handleClose={setLegalModalOpen} modalId='legalModal' />
            <PreOrderModal isOpen={preorderOpen} handleClose={setPreorderModalOpen}></PreOrderModal> 
        </div>
        </>
    )
}

export default Options;